import { css } from '@/styled-system/css';

export const verticalNavListStyles = css.raw({
  listStyle: 'none',
  paddingBlock: 'tightest',
  gap: 'tighter',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
});
